import { PRODUCT_TYPES } from '../../../shared/constants/products';

/**
 * Generates appropriate results text based on search context and product type
 *
 * @param {Array|Object} results - The search results
 * @param {string} searchText - The search text if any
 * @param {boolean} isPrebuiltPackageSearch - Whether this is a prebuilt package search
 * @param {string} productType - The type of product being searched
 * @returns {string} - The formatted results text
 */

export function getResultsText(
  numberOfResults: number,
  searchText?: string,
  isPrebuiltPackageSearch?: boolean,
  productType?: string
): string {
  const isPlural = numberOfResults !== 1;

  if (searchText) {
    return `results for "${searchText}"`;
  }

  if (isPrebuiltPackageSearch) {
    return `package result${isPlural ? 's' : ''}`;
  }

  if (productType === PRODUCT_TYPES.TIRES) {
    return `tire result${isPlural ? 's' : ''}`;
  }

  if (productType === PRODUCT_TYPES.WHEELS) {
    return `wheel result${isPlural ? 's' : ''}`;
  }

  if (productType === PRODUCT_TYPES.ACCESSORIES) {
    return `accessory result${isPlural ? 's' : ''}`;
  }
  return 'results';
}
